import { INVOICE_STATUS } from 'settings/constants/invoice'

const { INVOICED } = INVOICE_STATUS

export const checkIsWorkOrderLocked = (invoiceStatus, invoiceDate, checkIsLocked) =>
  invoiceStatus === INVOICED && checkIsLocked(invoiceDate)

export const checkIsInvoiceLocked = (invoiceDate, checkIsLocked) => checkIsLocked(invoiceDate)

export const checkIsPaymentLocked = (paymentDate, transactionDate, checkIsLocked) =>
  checkIsLocked(paymentDate) || checkIsLocked(transactionDate)
